import type { Board } from "./board";
import { Strings } from "./strings";

let nextId = 1;

export class Thing {
	static key: string;
	readonly id: string;
	active: boolean;
	board: Board | null;

	constructor() {
		this.id = String(nextId++);
		this.active = true;
		this.board = null;
	}

	// Called by Board.removeThing after detachment (this.board is already null).
	// Override to release owned things (indicators, looping sounds, etc.).
	onRemoveFromBoard(_board: Board): void {}

	getNameKey(): string {
		return "tname_" + (this.constructor as any).key;
	}

	getName(): string {
		const translated = Strings.get(this.getNameKey());
		if (translated === null) return (this.constructor as any).key;
		return translated;
	}

	getAnimationKey(): string {
		return (this.constructor as any).key;
	}

	shouldSerialize(): boolean {
		return true;
	}

	serialize(): Record<string, unknown> {
		return { type: (this.constructor as any).key, id: this.id, active: this.active };
	}
}
